import Choices from "choices.js";
import products from "/common/data/product-data.json" assert { type: "json" };

import { i18n } from "/common/client/js/i18n/i18n_instance.js";

export function initializeSelection(select, index) {
    const options = {
        renderChoiceLimit: -1,
        searchEnabled: true,
        removeItemButton: false,
        addChoices: true,
        addItems: true,
        placeholderValue: null,
        placeholder: true,
        noResultsText: "Keine Ergebnisse gefunden",
        noChoicesText: "Keine Auswahlmöglichkeiten",
        addItemText: (value, rawValue) => {
            return 'Bitte drücken Sie die Eingabetaste, um "' + value + '" hinzuzufügen';
        },
        searchPlaceholderValue: "Typen Sie, um nach dem Artikel zu suchen oder fügen Sie einen neuen Artikel hinzu",
        shouldSort: true,
        sorter: (a, b) => { },
        searchResultLimit: -1,
        fuseOptions: {
            threshold: 0.2,
            includeScore: true,
        },
    };
    if (index === 3) options.shouldSort = false;
    new Choices(select, options);
}

export function initializeSelections(articleSelects) {
    articleSelects.forEach((select, index) => {
        initializeSelection(select, index);
    });
}

export function getCategoryOptions(category) {
    const groupedDevices = [
        { label: "Funktionserweiterung", choices: products.Funktionserweiterung },
        { label: "Gateways", choices: products.Gateway },
        { label: "Zubehör", choices: products.Zubehoer1 },
    ];
    const options = {
        indoorstations: products.indoorstations,
        outdoorstations: products.outdoorstations,
        controlUnits: products.controlUnits,
        others: groupedDevices,
        all: [
            ...products.indoorstations,
            ...products.outdoorstations,
            ...products.controlUnits,
            ...groupedDevices.reduce((prev, curr) => [...prev, ...curr.choices], []),
        ],
    };
    if (category === "others") {
        return {
            optionsHtml: (
                `<option value="" selected>${i18n.__("no_article")}</option>` +
                options[category]
                    ?.map((group) => {
                        const groupOptions = group.choices
                            .map(
                                (article) => `<option value="${article}">${article}</option>`
                            )
                            .join("");
                        return `<optgroup label="${group.label}">${groupOptions}</optgroup>`;
                    })
                    .join("") || ""
            ), options: options[category]
        }
    }

    return {
        optionsHtml: (
            `<option value="" selected>${i18n.__("no_article")}</option>` +
            options[category]
                ?.map((article) => `<option value="${article}">${article}</option>`)
                .join("") || ""
        ),
        options: options[category]
    };
}
